import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { useStyles } from 'styles/material-styles/dialogModal'
import { DialogModalInterface } from 'ts/interfaces/DialogModalInterface'

const DialogModal = ({
  open,
  onClose,
  title = '',
  commentValue,
  onApply,
  isApplyDisabled = false,
  applyButtonText = 'APPLY',
  cancelButtonText = 'CANCEL',
  children,
}: DialogModalInterface) => {
  const { classes } = useStyles()

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className={classes.container}>
        <Box data-testid="title" className={classes.title}>
          {title}
          <IconButton aria-label="close" className={classes.iconButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText className={classes.contentText}>{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box className={classes.buttonContainer}>
          <Button
            onClick={() => {
              onApply(commentValue)
              onClose()
            }}
            disabled={isApplyDisabled}
            variant="contained"
            color="primary"
            className={classes.primaryButton}
          >
            {applyButtonText}
          </Button>
          <Button
            onClick={onClose}
            variant="outlined"
            color="secondary"
            className={classes.secondaryButton}
          >
            {cancelButtonText}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default DialogModal
